module.exports = __webpack_public_path__ + "static/media/trash.d1910f64.svg";